import i18n from "./i18n";
import { siteTitle } from "./settings";
import { GameI } from "./types";

const t = i18n.t;

/**
 * Get Property Value
 *
 * Get object property value (even if it's children property!!!)
 *
 * See https://stackoverflow.com/questions/37510640/how-to-get-property-value-from-a-javascript-object
 * BIG THANKS TO Pranav C Balan
 */
export const getPropertyValue = (obj: any, propName: string) => {
    return propName
        .split(".") // split string based on `.`
        .reduce(function (o, k) {
            return o && o[k]; // get inner property if `o` is defined else get `o` and return
        }, obj); // set initial value as object
};

/**
 * Object to Array
 *
 * Convert object of given type to array of given type.
 * Use to convert Firebase Realtime Database results to arrays for later usage.
 *
 * @param object Object of given type.
 * @returns Array of given type.
 */
export const objectToArray = <T>(object: T): T[] => {
    const result: T[] = [];
    for (const item in object) {
        result.push(object[item] as T);
    }
    return result;
};

/**
 * Get Game Preview Image
 *
 * Return preview image filename and alt text as one array.
 * @param game Object of game data.
 * @returns Array of image filename and alt text.
 */
export const getGamePreviewImage = (game: GameI): string[] => {
    const result: string[] = ["", ""];

    if (game.picture.poster) {
        result[0] = game.picture.poster;
        result[1] = `${game.title} (${String(t("Poster"))})`;
    } else if (game.picture.menu) {
        result[0] = game.picture.menu;
        result[1] = `${game.title} (Menu)`;
    } else if (game.picture.intro) {
        result[0] = game.picture.intro;
        result[1] = `${game.title} (Intro)`;
    } else if (game.picture.inGame) {
        result[0] = game.picture.inGame.replace("[N]", "1") + ".png";
        result[1] = `${game?.title} (${String(t("In-game Picture"))})`;
    }

    return result;
};

export const setPageTitle = (title: string) => {
    document.title = `${title} | ${siteTitle}`;
};
